import update from 'immutability-helper';
import { ApiInquiryInvoice } from 'src/models';
import { ActionType, defaultAction } from 'src/redux/types';
import { ACTION_TYPES } from './types';

export type ApiInquiryState = {
  invoice: {
    data: ApiInquiryInvoice[];
    isLoading: boolean;
    totalEntry: number;
  };
};

const initialState: ApiInquiryState = {
  invoice: {
    data: [],
    isLoading: false,
    totalEntry: 0,
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.API_INQUIRY_LOAD_INVOICE_LIST:
      return update(state, {
        invoice: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.API_INQUIRY_LOAD_INVOICE_LIST_SUCCESS:
      return update(state, {
        invoice: {
          $set: {
            data: payload.data.invoices,
            isLoading: false,
            totalEntry: payload.data.total,
          },
        },
      });
    case ACTION_TYPES.API_INQUIRY_LOAD_INVOICE_LIST_FAILED:
      return update(state, {
        invoice: {
          isLoading: {
            $set: false,
          },
        },
      });
    default:
      return state;
  }
};
